const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const TokenLogin = () => import('~/pages/auth/token_login').then(m => m.default || m)
const ConfirmEmail = () => import('~/pages/auth/confirm_email').then(m => m.default || m)
const AdminLoginAsPatient = () => import('~/pages/auth/login_as_patient').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)
const Landing = () => import('~/pages/landing').then(m => m.default || m)
const Confirmed = () => import('~/pages/confirmed').then(m => m.default || m)
const Journey = () => import('~/pages/patient_journey').then(m => m.default || m)
const Home = () => import('~/pages/patient/home').then(m => m.default || m)
const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)
const AdverseEvents = () => import('~/pages/clinician/adverse_events').then(m => m.default || m)
const ConcomitantMedication = () => import('~/pages/clinician/concomitant_medication').then(m => m.default || m)
const Dashboard = () => import('~/pages/clinician/dashboard').then(m => m.default || m)
const Messages = () => import('~/pages/messages').then(m => m.default || m)
const PatientEditor = () => import('~/pages/clinician/patient_editor').then(m => m.default || m)
const ClinicianWrapper = () => import('~/pages/clinician/clinician_wrapper').then(m => m.default || m)
const PatientWrapper = () => import('~/pages/patient/patient_wrapper').then(m => m.default || m)
const PatientOverview = () => import('~/pages/clinician/patient_overview').then(m => m.default || m)
const PatientPeriodOverview = () => import('~/pages/clinician/patient_period_overview').then(m => m.default || m)
const InclusionExclusionCriteria = () => import('~/pages/clinician/inclusion_exclusion_criteria').then(m => m.default || m)
const Randomisation = () => import('~/pages/clinician/randomisation').then(m => m.default || m)
const RandomisationOutcome = () => import('~/pages/clinician/randomisation_outcome').then(m => m.default || m)
const InformedConsent = () => import('~/pages/clinician/informed_consent').then(m => m.default || m)
const Demographics = () => import('~/pages/clinician/demographics').then(m => m.default || m)
const Imaging = () => import('~/pages/clinician/imaging').then(m => m.default || m)
const ImagingFollowup = () => import('~/pages/clinician/imaging_followup').then(m => m.default || m)
const XrayFollowup = () => import('~/pages/clinician/xray_followup').then(m => m.default || m)
const MedicalHistory = () => import('~/pages/clinician/medical_history').then(m => m.default || m)
const PhysicalExamination = () => import('~/pages/clinician/physical_examination').then(m => m.default || m)
const HarrisHipScore = () => import('~/pages/clinician/harris_hip_score').then(m => m.default || m)
const Employment = () => import('~/pages/patient/employment').then(m => m.default || m)
const OxfordHipScore = () => import('~/pages/patient/oxford_hip_score').then(m => m.default || m)
const Ihot33 = () => import('~/pages/patient/ihot33').then(m => m.default || m)
const Hagos = () => import('~/pages/patient/hagos').then(m => m.default || m)
const Paindetect = () => import('~/pages/patient/paindetect').then(m => m.default || m)
const DecisionRegret = () => import('~/pages/patient/decision_regret').then(m => m.default || m)
const SAMS = () => import('~/pages/patient/sams').then(m => m.default || m)
const PSQI = () => import('~/pages/patient/psqi').then(m => m.default || m)
const PGSGA = () => import('~/pages/patient/pgsga').then(m => m.default || m)
const C30 = () => import('~/pages/patient/c_30').then(m => m.default || m)
const MunichChronotype = () => import('~/pages/patient/munich_chronotype').then(m => m.default || m)
const VaizeyIncontinenceScore = () => import('~/pages/patient/vaizey_incontinence_score').then(m => m.default || m)
const BowelDisease = () => import('~/pages/patient/bowel_disease').then(m => m.default || m)
const SpecimenSHQC22 = () => import('~/pages/patient/specimen_shq_c22').then(m => m.default || m)
const C29 = () => import('~/pages/patient/c_29').then(m => m.default || m)
const UkccV2 = () => import('~/pages/patient/ukcc_v2').then(m => m.default || m)
const Consent = () => import('~/pages/patient/consent').then(m => m.default || m)
const ReturningConsent = () => import('~/pages/patient/returning_consent').then(m => m.default || m)
const PASE = () => import('~/pages/patient/pase').then(m => m.default || m)
const GastrointestinalSymptoms = () => import('~/pages/patient/gastrointestinal_symptoms').then(m => m.default || m)
const Eq5d = () => import('~/pages/patient/eq5d').then(m => m.default || m)
const UclaActivityScore = () => import('~/pages/patient/ucla_activity_score').then(m => m.default || m)
const HealthServiceUse = () => import('~/pages/patient/health_service_use').then(m => m.default || m)
const ForgottenJointScore = () => import('~/pages/patient/forgotten_joint_score').then(m => m.default || m)
const OperativeDetails = () => import('~/pages/clinician/operative_details').then(m => m.default || m)
const OperativeDetailsBlinded = () => import('~/pages/clinician/operative_details_blinded').then(m => m.default || m)
const Treatment = () => import('~/pages/clinician/treatment').then(m => m.default || m)
const HipHistory = () => import('~/pages/clinician/hip_history').then(m => m.default || m)

const TableList = () => import('~/pages/admin_table/TableList.vue').then(m => m.default || m)
const Table = () => import('~/pages/admin_table/Table.vue').then(m => m.default || m)
const Record = () => import('~/pages/admin_table/Record.vue').then(m => m.default || m)

export default [
  { path: '/', name: 'welcome', component: Welcome },
  { path: '/token/:dest/:id/:token', name: 'token', component: TokenLogin },
  { path: '/confirm/token/:id/:token', name: 'confirm', component: ConfirmEmail },
  { path: '/login_as_patient/:patient', name: 'login_as_patient', component: AdminLoginAsPatient },

  { path: '/login', name: 'login', component: Login },
  { path: '/landing', name: 'landing', component: Landing },
  { path: '/confirmed', name: 'confirmed', component: Confirmed },
  { path: '/journey', name: 'journey', component: Journey },
  
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  { path: '/home', name: 'home', component: Home },
  { path: '/messages', name: 'messages', component: Messages },
  { path: '/dashboard', name: 'dashboard', component: Dashboard },
  { path: '/add_patient', name: 'add_patient', component: PatientEditor },
  /* Patient routes */
  {
    path: '/questionnaires',
    component: PatientWrapper,
    children: [
      { path: '/employment', name: 'employment_patient', component: Employment },
      { path: '/oxford_hip_score', name: 'oxford_hip_score_patient', component: OxfordHipScore },
      { path: '/ihot33/:page', name: 'ihot33_patient', component: Ihot33 },
      { path: '/hagos/:page', name: 'hagos_patient', component: Hagos },
      { path: '/paindetect', name: 'paindetect_patient', component: Paindetect },
      { path: '/decision_regret', name: 'decision_regret_patient', component: DecisionRegret },
      { path: '/c_30', name: 'c_30_patient', component: C30 },
      { path: '/sams', name: 'sams_patient', component: SAMS },
      { path: '/munich_chronotype/:page', name: 'munich_chronotype_patient', component: MunichChronotype},
      { path: '/psqi/:page', name: 'psqi_patient', component: PSQI },
      { path: '/pgsga/:page', name: 'pgsga_patient', component: PGSGA },
      { path: '/vaizey_incontinence_score', name: 'vaizey_incontinence_score_patient', component: VaizeyIncontinenceScore },
      { path: '/bowel_disease', name: 'bowel_disease_patient', component: BowelDisease },
      { path: '/specimen_shq_c22/:page', name: 'specimen_shq_c22_patient', component: SpecimenSHQC22 },
      { path: '/c_29/:page', name: 'c_29_patient', component: C29 },
      { path: '/ukcc_v2/:page', name: 'ukcc_v2_patient', component: UkccV2 },
      { path: '/consent', name: 'consent_patient', component: Consent },
      { path: '/returning_consent', name: 'returning_consent_patient', component: ReturningConsent },
      { path: '/pase/:page', name: 'pase_patient', component: PASE },
      { path: '/gastrointestinal_symptoms/:page', name: 'gastrointestinal_symptoms_patient', component: GastrointestinalSymptoms },
      { path: '/eq5d/:page', name: 'eq5d_patient', component: Eq5d },
      { path: '/ucla_activity_score', name: 'ucla_activity_score_patient', component: UclaActivityScore },
      { path: '/health_service_use', name: 'health_service_use_patient', component: HealthServiceUse },
      { path: '/health_service_use_postop', name: 'health_service_use_postop_patient', component: HealthServiceUse },
      { path: '/forgotten_joint_score', name: 'forgotten_joint_score_patient', component: ForgottenJointScore },
    ]
  },
  /* Clinician routes */
  {
    path: '/patient/:patient',
    component: ClinicianWrapper,
    children: [
      { path: '/', name: 'patient_overview', component: PatientOverview },
      { path: 'edit', name: 'edit_patient', component: PatientEditor },
      { path: 'messages', name: 'patient_messages', component: Messages },
      { path: 'inclusion_exclusion_criteria', name: 'inclusion_exclusion_criteria', component: InclusionExclusionCriteria },
      { path: 'adverse_event', name: 'adverse_event', component: AdverseEvents },
      { path: 'concomitant_medication', name: 'concomitant_medication', component: ConcomitantMedication },
      { path: 'xray_followup', name: 'xray_followup', component: XrayFollowup },
      { path: 'randomisation', name: 'randomisation', component: Randomisation },
      { path: 'randomisation_outcome', name: 'randomisation_outcome', component: RandomisationOutcome },
      { path: ':period', name: 'patient_period_overview', component: PatientPeriodOverview },
      { path: ':period/informed_consent', name: 'informed_consent', component: InformedConsent },
      { path: ':period/demographics', name: 'demographics', component: Demographics },
      { path: ':period/imaging', name: 'imaging', component: Imaging },
      { path: ':period/imaging_followup', name: 'imaging_followup', component: ImagingFollowup },
      { path: ':period/medical_history', name: 'medical_history', component: MedicalHistory },
      { path: ':period/physical_examination', name: 'physical_examination', component: PhysicalExamination },
      { path: ':period/harris_hip_score', name: 'harris_hip_score', component: HarrisHipScore },
      { path: ':period/employment', name: 'employment', component: Employment },
      { path: ':period/oxford_hip_score', name: 'oxford_hip_score', component: OxfordHipScore },
      { path: ':period/ihot33/:page', name: 'ihot33', component: Ihot33 },
      { path: ':period/hagos/:page', name: 'hagos', component: Hagos },
      { path: ':period/paindetect', name: 'paindetect', component: Paindetect },
      { path: 'period/decision_regret', name: 'decision_regret', component: DecisionRegret },
      { path: 'period/c_30', name: 'c_30', component: C30 },
      { path: 'period/sams', name: 'sams', component: SAMS },
      { path: 'period/psqi/:page', name: 'psqi', component: PSQI },
      { path: 'period/pgsga/:page', name: 'pgsga', component: PGSGA },
      { path: 'period/munich_chronotype/:page', name: 'munich_chronotype', component: MunichChronotype },
      { path: 'period/vaizey_incontinence_score', name: 'vaizey_incontinence_score', component: VaizeyIncontinenceScore },
      { path: 'period/bowel_disease', name: 'bowel_disease', component: BowelDisease },
      { path: 'period/specimen_shq_c22/:page', name: 'specimen_shq_c22', component: SpecimenSHQC22 },
      { path: 'period/c_29/:page', name: 'c_29', component: C29 },
      { path: ':period/ukcc_v2/:page', name: 'ukcc_v2', component: UkccV2 },
      { path: ':period/consent', name: 'consent', component: Consent },
      { path: ':period/returning_consent', name: 'returning_consent', component: ReturningConsent },
      { path: ':period/pase/:page', name: 'pase', component: PASE },
      { path: ':period/gastrointestinal_symptoms/:page', name: 'gastrointestinal_symptoms', component: GastrointestinalSymptoms },
      { path: ':period/eq5d/:page', name: 'eq5d', component: Eq5d },
      { path: ':period/ucla_activity_score', name: 'ucla_activity_score', component: UclaActivityScore },
      { path: ':period/health_service_use', name: 'health_service_use', component: HealthServiceUse },
      { path: ':period/health_service_use_postop', name: 'health_service_use_postop', component: HealthServiceUse },
      { path: ':period/forgotten_joint_score', name: 'forgotten_joint_score', component: ForgottenJointScore },
      { path: ':period/operative_details', name: 'operative_details', component: OperativeDetails },
      { path: ':period/operative_details_blinded', name: 'operative_details_blinded', component: OperativeDetailsBlinded },
      { path: ':period/treatment', name: 'treatment', component: Treatment },
      { path: ':period/hip_history', name: 'hip_history', component: HipHistory },
    ]
  },
  {
    path: '/settings',
    component: Settings,
    children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'password', name: 'settings.password', component: SettingsPassword }
    ]
  },
  {
    path: '/admin',
    component: TableList,
    name: 'tablelist',
  },
  {
    path: '/admin/:table',
    component: Table,
    name: 'table',
  },
  {
    path: '/admin/:table/:id',
    component: Record,
    name: 'record',
  },
  { path: '*', component: NotFound }
]
